module.exports = __webpack_public_path__ + "img/95eb77d73cbc8f0166923fd43fa93b84.svg";